import React from 'react';
import { Button, Image } from 'antd';
import {
  FallbackWrapper,
  Left,
  LogoLink,
  Mid,
  ProductLabel,
  Right,
  StyledMenu,
} from './styled';
import ConvivaLogo from './Conviva_Logo_Light.png';
import { QuestionOutlined } from '@ant-design/icons';

const FallbackNav = () => {
  const apphubMode = !!(window as any).__POWERED_BY_QIANKUN__;
  const productName = 'MDS';

  if (apphubMode) {
    return null;
  }

  return (
    <FallbackWrapper>
      <Left>
        <StyledMenu>
          <input type="checkbox" id="fallback-menu-toggle" />
          <label htmlFor="fallback-menu-toggle" className="menu-button">
            ☰
          </label>
          <ul className="menu-content">
            <li>
              <a
                href="/app/app-insights/dashboard/app-experience"
                target="_BLANK"
              >
                Digital Product Insights
              </a>
            </li>
            <li>
              <a
                href="/app/experience-insights/dashboard/trends"
                target="_BLANK"
              >
                Video Streaming Insights
              </a>
            </li>
          </ul>
        </StyledMenu>
        <LogoLink href={'/'} className="color-critical">
          <Image src={ConvivaLogo} alt="Conviva Logo" preview={false} />
        </LogoLink>
        {productName && <ProductLabel>{productName}</ProductLabel>}
      </Left>
      <Mid></Mid>
      <Right>
        <Button
          href="https://pulse.conviva.com/learning-center/content/main/main.htm"
          target="_blank"
          type="default"
          shape="circle"
          icon={<QuestionOutlined />}
          size="small"
          style={{
            fontSize: 12,
            color: '#5f5f5f',
          }}
        />
      </Right>
    </FallbackWrapper>
  );
};

export default FallbackNav;
